var _path, _g, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatapoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8421 8.83109L12.4997 1.77478L0.157227 8.83109V22.9437L10.7085 28.976L12.4995 30V29.9999L12.4997 30L12.5003 29.9996V30L17.1612 27.335L24.8421 22.9437V22.9431L24.8422 22.943V8.83298L24.8428 8.83264L24.8422 8.8323V8.83105L24.8421 8.83114V8.83109Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4706 1.77478L24.813 8.83109V8.83224L24.8137 8.83264L24.813 8.83305V22.9437L12.4707 30L12.4706 30L0.128174 22.9437V8.83109L12.4706 1.77478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 1.77478L24.8421 8.83109V22.9437L12.4997 30L0.157227 22.9437V8.83109L12.4997 1.77478Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32495 26.4552L12.4959 29.9836V22.9333L6.32495 19.3992V26.4552Z",
    fill: "#007AFF",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31665 19.4166L12.4876 22.9451V15.8948L6.31665 12.3606V19.4166Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5044 22.9327L18.6753 19.4042V26.4545L12.5044 29.9886V22.9327Z",
    fill: "#007AFF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.675 19.4154L24.846 15.887V22.9373L18.675 26.4714V19.4154Z",
    fill: "#007AFF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4958 15.8871L18.6668 12.3587V19.409L12.4958 22.9431V15.8871Z",
    fill: "#007AFF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.667 12.3699L24.8379 8.84144V15.8917L18.667 19.4259V12.3699Z",
    fill: "#007AFF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.154053 15.8808L6.32501 19.4093V12.359L0.154053 8.82483V15.8808Z",
    fill: "#007AFF",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.157715 22.927L6.32867 26.4554V19.4051L0.157715 15.871V22.927Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32731 5.2966L0.156554 8.84506L6.32731 12.3848L12.4969 8.84515L6.32731 5.2966Z",
    fill: "#007AFF",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6698 5.28635L12.4991 8.8348L18.6698 12.3746L24.8394 8.8349L18.6698 5.28635Z",
    fill: "#A7D2FF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5028 8.83224L6.33209 12.3807L12.5029 15.9205L18.6724 12.3808L12.5028 8.83224Z",
    fill: "#A7D2FF",
    fillOpacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5028 1.74435L6.33209 5.29281L12.5029 8.83259L18.6724 5.29291L12.5028 1.74435Z",
    fill: "#007AFF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31665 19.4015L12.4876 22.9299V15.8796L6.31665 12.3455V19.4015Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4875 15.8871L18.6585 12.3587V19.409L12.4875 22.9431V15.8871Z",
    fill: "#1F8AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5026 8.81711L6.33185 12.3656L12.5026 15.9053L18.6722 12.3657L12.5026 8.81711Z",
    fill: "#2B90FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32886 18.1828L12.4432 14.6478V14.65L18.6566 18.1939L18.6738 12.3691L12.4432 8.77637L6.32886 12.3601V18.1828Z",
    fill: "#92C6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4709 15.8796L18.6369 12.354V19.3986L12.4709 22.9299V15.8796Z",
    fill: "#1F8AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.486 8.8157L6.32023 12.3613L12.486 15.8982L18.6506 12.3614L12.486 8.8157Z",
    fill: "#459EFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30469 19.3912L12.4706 22.9168V15.8722L6.30469 12.3409V19.3912Z",
    fill: "#007AFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatapoint);
export default __webpack_public_path__ + "static/media/datapoint.955ac11a6c3d143e8170c5f21781c3a9.svg";
export { ForwardRef as ReactComponent };